import React, { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import {
    Button,
    Checkbox,
    Col,
    Collapse,
    CollapseProps,
    DatePicker,
    Form,
    Input,
    Row,
    Select,
    Spin
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import {
    getDivergenceNextPlanPeriod,
    getDivergenceNextPlanPeriodTest,
    getFrequencyType
} from 'app/entities/common/common.reducer';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import DatePickerCustomValidate from 'app/shared/component/DatePickerCUstom/DatePickerCustomValidate';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import { getInfo } from '../../../objective/objective.reducer';
import {
    copyEntity,
    getCopyEntity,
    getEntity,
    reset as resetQualitative,
    updateCopyEntity,
    updateCopyEntityVer2,
} from '../../kr-qualitative.reducer';
import ObjectiveKRRowSelection from 'app/entities/objective/form/view-row-selection/objective-kr';

type KrFormType = {
    onClose: (isReload?: boolean) => void;
    idObjective?: string;
    planPeriodIdSelected?: string;
    idKrBaseSelected?: string;
    krTypeRequest?: number;
    planPeriodType?: PlantPeriodType;
    handleChangeKRType: (value: KrTypes) => void;
    KrType: KrTypes;
    isEdit: boolean;
    isReadOnly?: boolean;
    selectedPeriod?: number;
};

export const CopyKRQualitative = ({ onClose, isEdit, planPeriodIdSelected, idObjective, isReadOnly, idKrBaseSelected, krTypeRequest, planPeriodType, handleChangeKRType, KrType, selectedPeriod }: KrFormType) => {
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();
    const isNew = idKrBaseSelected === undefined || idKrBaseSelected === null;
    const { id } = useParams();

    const krQualitativeEntity = useAppSelector(state => state.krQualitative.entity);
    const objectiveEntity = useAppSelector(state => state.objective.entity);
    const planPeriodList = useAppSelector(state => state.planPeriod.entities);
    const updatingQualitative = useAppSelector(state => state.krQualitative.updating);
    const krQualitativeUpdateSuccess = useAppSelector(state => state.krQualitative.updateSuccess);
    const loadingQualitative = useAppSelector(state => state.krQualitative.loading);
    const filtersObjective = useAppSelector(state => state.filters.objective);

    // common data
    const employeeList = useAppSelector(state => state.common.personPositions);
    const frequencies = useAppSelector(state => state.common.frequencies);
    const qualityEvaluationTypes = useAppSelector(state => state.common.qualityType);
    const krTypes = useAppSelector(state => state.common.krType);
    const associateTypes = useAppSelector(state => state.common.associates);
    const lesserPlanPeriodTypes = useAppSelector(state => state.common.nextLesserPlanPeriod);
    const filters = useAppSelector(state => state.filters.objective);

    const [planPeriodSelected, setPlanPeriodSelected] = useState<any>();
    const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
    const [lesserPlanPeriod, setLesserPlanPeriod] = useState(null);
    const [isSaveChange, setSaveChange] = useState(false);
    const [showMonth, setShowMonth] = useState([0]);
    const [isOpenModal, setOpenModal] = useState(false);

    // define values for max, min dates
    const [mintDate, setMinDate] = useState();
    const [maxDate, setMaxDate] = useState();

    // form watcher data

    const planPeriodIdValues = Form.useWatch('planPeriodId', form);

    const purposeValueQuarterFirstValues = Form.useWatch('purpose-quarter-0', form);
    const purposeValueQuarterFirstMonthFirstValues = Form.useWatch('purpose-quarter-0-month-0', form);
    const purposeValueQuarterFirstMonthSecondValues = Form.useWatch('purpose-quarter-0-month-1', form);
    const purposeValueQuarterFirstMonthThirdValues = Form.useWatch('purpose-quarter-0-month-2', form);

    // define data collapse
    const items: CollapseProps['items'] = [
        {
            key: '1',
            label: 'Thông tin mục tiêu',
            children: (
                <Row>
                    <Col md={7}>
                        <Form.Item label="Lĩnh vực">
                            <Input className="w-100" value={objectiveEntity?.fieldName} disabled size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={7}>
                        <Form.Item label="Dự án">
                            <Input className="w-100" value={objectiveEntity?.name} disabled size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={8}>
                        <Form.Item label="Nhóm công việc">
                            <Input className="w-100" value={objectiveEntity?.workTypeName} disabled size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={24}>
                        <Form.Item label="Nội dung mục tiêu">
                            <TextArea disabled value={objectiveEntity?.purpose} placeholder="Nhập nội dung mục tiêu" size="large" />
                        </Form.Item>
                    </Col>
                    <span className="cursor-pointer text-primary" onClick={() => handleEditObjective()}>
                        {`Thông tin chi tiết >`}
                    </span>
                </Row>
            ),
        },
    ];

    const handleClose = (isReload = undefined) => {
        form.resetFields();
        dispatch(resetQualitative());
        onClose(isReload ?? isSaveChange);
    };

    useEffect(() => {
        form.setFieldsValue({ krType: KrType });
    }, [KrType]);

    useEffect(() => {
        dispatch(getInfo(id ?? idObjective));
        if (isNew) {
            form.resetFields();
        } else if (!isEdit) {
            dispatch(getCopyEntity({ idKrBaseSelected, planPeriodId: planPeriodIdSelected, okrVersion: filtersObjective?.okrVersion }));
        }
        else {
            dispatch(getEntity({ idKrBaseSelected, planPeriodId: planPeriodIdSelected }));
        }
    }, []);

    useEffect(() => {
        setLesserPlanPeriod(lesserPlanPeriodTypes);
    }, [lesserPlanPeriodTypes]);

    // Set default values for quarters and months when creating new KR
    useEffect(() => {
        if (isNew && lesserPlanPeriod && lesserPlanPeriod?.quarters?.length > 0) {
            const defaultValues = {};

            // Set default values for quarters
            lesserPlanPeriod.quarters.forEach((item, index) => {
                if (item.quarter) {
                    const startDateKey = `startDate-quarter-${index}`;
                    const dueDateKey = `dueDate-quarter-${index}`;
                    // Only set if field doesn't have a value yet
                    if (!form.getFieldValue(startDateKey)) {
                        defaultValues[startDateKey] = dayjs(item.quarter.startDate);
                    }
                    if (!form.getFieldValue(dueDateKey)) {
                        defaultValues[dueDateKey] = dayjs(item.quarter.endDate);
                    }
                }
            });

            // Set default values for months
            if (lesserPlanPeriodTypes && lesserPlanPeriodTypes?.quarters?.length > 0) {
                lesserPlanPeriodTypes.quarters.forEach((quarter, quarterIndex) => {
                    if (quarter.months && quarter.months.length > 0) {
                        quarter.months.forEach((month, monthIndex) => {
                            const startDateKey = `startDate-quarter-${quarterIndex}-month-${monthIndex}`;
                            const dueDateKey = `dueDate-quarter-${quarterIndex}-month-${monthIndex}`;
                            // Only set if field doesn't have a value yet
                            if (!form.getFieldValue(startDateKey)) {
                                defaultValues[startDateKey] = dayjs(month.startDate);
                            }
                            if (!form.getFieldValue(dueDateKey)) {
                                defaultValues[dueDateKey] = dayjs(month.endDate);
                            }
                        });
                    }
                });
            }

            if (Object.keys(defaultValues).length > 0) {
                form.setFieldsValue(defaultValues);
            }
        }
    }, [lesserPlanPeriod, lesserPlanPeriodTypes, isNew, form]);

    useEffect(() => {
        form.validateFields(['purpose-quarter-0-month-0', 'purpose-quarter-0-month-1', 'purpose-quarter-0-month-2']);
    }, [purposeValueQuarterFirstMonthFirstValues, purposeValueQuarterFirstMonthSecondValues, purposeValueQuarterFirstMonthThirdValues, purposeValueQuarterFirstValues])
    // useEffect(() => {
    //     form.validateFields(['purpose-quarter-1-month-0', 'purpose-quarter-1-month-1', 'purpose-quarter-1-month-2']);
    // }, [purposeValueQuarterSecondMonthFirstValues, purposeValueQuarterSecondMonthSecondValues, purposeValueQuarterSecondMonthThirdValues, purposeValueQuarterSecondValues])
    // useEffect(() => {
    //     form.validateFields(['purpose-quarter-2-month-0', 'purpose-quarter-2-month-1', 'purpose-quarter-2-month-2']);
    // }, [purposeValueQuarterThirdMonthFirstValues, purposeValueQuarterThirdMonthSecondValues, purposeValueQuarterThirdMonthThirdValues, purposeValueQuarterThirdValues])
    // useEffect(() => {
    //     form.validateFields(['purpose-quarter-3-month-0', 'purpose-quarter-3-month-1', 'purpose-quarter-3-month-2']);
    // }, [purposeValueQuarterFourthMonthFirstValues, purposeValueQuarterFourthMonthSecondValues, purposeValueQuarterFourthMonthThirdValues, purposeValueQuarterFourthValues])

    useEffect(() => {
        if (planPeriodIdValues) {
            handleChangePlanPeriod(planPeriodIdValues);
        }
    }, [planPeriodIdValues]);

    useEffect(() => {
        if (krQualitativeEntity && !isNew) {
            const objectQuarter = {};
            const objectMonth = {};
            const entityCommon = { ...krQualitativeEntity };
            let quarters = []
            let months = []

            if (krQualitativeEntity?.quarters && krQualitativeEntity?.quarters.length > 0) {
                quarters = krQualitativeEntity?.quarters?.map((x: any, index) => {
                    if (x.quarter) {
                        return {
                            'startDate-quarter': x.quarter.startDate,
                            'dueDate-quarter': x.quarter.dueDate,
                            'purpose-quarter': x.quarter.purpose,
                        };
                    }
                });
                krQualitativeEntity?.quarters?.map((item: any, index) => {
                    if (item.months && item.months.length > 0) {
                        {
                            months = months.concat(item.months.map((x: any) => {
                                if (x) {
                                    return {
                                        [`startDate-quarter-${index}-month`]: x.startDate,
                                        [`dueDate-quarter-${index}-month`]: x.dueDate,
                                        [`purpose-quarter-${index}-month`]: x.purpose,
                                    };
                                }
                            }));
                        }
                    }
                });
            }
            quarters?.forEach((item, index) => {
                if (item) {
                    Object.entries(item).forEach(([key, value]: any) => {
                        if (key.includes('startDate') || key.includes('dueDate')) {
                            objectQuarter[`${`${key}-${index}`}`] = dayjs(value);
                        } else {
                            objectQuarter[`${`${key}-${index}`}`] = value;
                        }
                    });
                }
            });

            months?.forEach((item, index) => {
                if (item) {
                    Object.entries(item).forEach(([key, value]: any) => {
                        if (key.includes('startDate') || key.includes('dueDate')) {
                            objectMonth[`${`${key}-${index}`}`] = dayjs(value);
                        } else {
                            objectMonth[`${`${key}-${index}`}`] = value;
                        }
                    });
                }
            });

            const entity = {
                ...entityCommon,
                tags: _.join(entityCommon.tags, ','),
                startDate: dayjs(entityCommon?.year?.startDate),
                dueDate: dayjs(entityCommon?.year?.dueDate),
                purpose: entityCommon?.year?.purpose,
                informEmails: entityCommon.raci?.informEmails,
                consultantIds: entityCommon.raci?.consultantIds,
                accountableId: entityCommon.raci?.accountableId,
                responsibleIds: entityCommon.raci?.responsibleIds,
                ...objectQuarter,
                ...objectMonth,
            };
            form.setFieldsValue(entity);
        }
    }, [krQualitativeEntity]);

    // Function to extract the quarter and month index
    const extractQuarterAndMonth = (item: string) => {
        const match = item.match(/quarter-(\d+)-month-(\d+)/);
        if (match) {
            return { quarter: match[1], month: match[2] };
        }
        return null;
    };

    // eslint-disable-next-line complexity
    const handleSubmit = values => {
        const {
            tags,
            informEmails,
            consultantIds,
            accountableId,
            responsibleIds,
            associateIds,
            evaluationMethods,
            krType,
            planPeriodId,
            frequencyId,
            accessIds,
            sendingNotification,
            purpose,
            startDate,
            dueDate,
            alignCode,
            ...remainingValues
        } = values;
        let quarters = [];
        const months = [];
        // Khởi tạo mảng khóa
        const keys = Object.keys(remainingValues);
        // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
        const groupedKeys = _.chunk(keys, 3);

        // Separate arrays using lodash filter

        const monthArray = _.filter(groupedKeys, item => item && item[0] && item[0].includes('month'));
        const quarterArray = _.differenceWith(groupedKeys, monthArray, _.isEqual);
        // Tạo mảng mới từ các nhóm khóa
        quarters = _.map(quarterArray, group => {
            const mapper = _.map(group, key => {
                if (key.includes('startDate') || key.includes('dueDate')) {
                    return dayjs(remainingValues[key]).format(APP_LOCAL_DATE_FORMAT_PAYLOAD); // Định dạng ngày theo ý muốn
                }
                return remainingValues[key];
            });
            return _.zipObject(['purpose', 'startDate', 'dueDate'], mapper);
        });

        // Group data into the array by quarter and month
        _.forEach(remainingValues, (value, key) => {
            const indices = extractQuarterAndMonth(key);
            if (indices) {
                const { quarter, month } = indices;
                if (!months[quarter]) months[quarter] = [];
                // Ensure the month is correctly filled within the quarter
                if (!months[quarter][month]) {
                    months[quarter][month] = {};
                }

                // Add the value to the appropriate quarter and month
                const type = key.split('-')[0]; // Extract 'dueDate', 'purpose', 'startDate'
                months[quarter][month][type] = dayjs.isDayjs(value) ? dayjs(value).format(APP_LOCAL_DATE_FORMAT_PAYLOAD) : value;
            }
        });

        quarters = quarters.map((item, index) => {
            return {
                quarter: {
                    ...item,
                    planPeriodId: lesserPlanPeriod?.quarters[index]?.quarter.id,
                    purpose: item.purpose !== undefined && item.purpose != null ? item.purpose : "",
                },
                months: months[index] ? months[index].map((itemMonth, indexMonth) => {
                    return {
                        ...itemMonth,
                        planPeriodId: lesserPlanPeriodTypes?.quarters && lesserPlanPeriodTypes?.quarters[index] ? lesserPlanPeriodTypes?.quarters[index].months[indexMonth].id : "",
                        startDate: itemMonth.startDate !== undefined ? itemMonth.startDate : (lesserPlanPeriodTypes?.quarters && lesserPlanPeriodTypes?.quarters[index] ? lesserPlanPeriodTypes?.quarters[index]?.months[indexMonth].startDate : null),
                        dueDate: itemMonth.dueDate !== undefined ? itemMonth.dueDate : (lesserPlanPeriodTypes?.quarters && lesserPlanPeriodTypes?.quarters[index] ? lesserPlanPeriodTypes?.quarters[index]?.months[indexMonth].endDate : null),
                        purpose: itemMonth.purpose !== undefined && itemMonth.purpose != null ? itemMonth.purpose : ""
                    };
                }) : []
            };
        });

        const detailEntity = !isNew ? krQualitativeEntity : undefined;
        const entity = {
            ...detailEntity,
            evaluationMethods,
            krType,
            accessIds,
            planPeriodId,
            frequencyId,
            sendingNotification,
            associateIds: associateIds ?? [],
            tags: _.split(tags, ','),
            objectiveId: id ?? idObjective,
            raci: {
                informEmails: _.split(informEmails, ','),
                consultantIds,
                accountableId,
                responsibleIds,
            },
            quarters,
            year: {
                startDate: dayjs(startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                dueDate: dayjs(dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                purpose,
                planPeriodId: lesserPlanPeriod?.year.id
            },
        };
        if (isNew) {
            dispatch(copyEntity(entity)).then(res => {
                if (res && res.payload) {
                    handleClose(true);
                }
            });
        } else {
            dispatch(updateCopyEntityVer2(entity)).then(res => {
                if (res && res.payload) {
                    handleClose(true);
                }
            });
        }
    };

    const handleChangePlanPeriod = (planPeriod: string) => {
        dispatch(getFrequencyType(planPeriod));
        handleLesserPlanPeriod(planPeriod);
        const planPeriodDetails = _.find(planPeriodList, o => o.id === planPeriod);
        if (planPeriodDetails) {
            if (isNew) {
                form.setFieldValue('startDate', dayjs(planPeriodDetails.startDate));
                form.setFieldValue('dueDate', dayjs(planPeriodDetails.endDate));
            }
            setPlanPeriodSelected(planPeriodDetails);
            setMinDate(planPeriodDetails.startDate);
            setMaxDate(planPeriodDetails.endDate);
        }
    };

    const handleMapperResultByPlanPeriod = () => {
        if (lesserPlanPeriod && lesserPlanPeriod?.quarters?.length > 0) {
            // When editing, use data from krQualitativeEntity
            if (!isNew && krQualitativeEntity && krQualitativeEntity?.quarters && krQualitativeEntity?.quarters.length > 0) {
                return krQualitativeEntity?.quarters?.map((item, index) => {
                    const isQuarterDisabled = isReadOnly || item?.quarter?.isEditAble === false;
                    return (
                        <Row key={item.id}>
                            <Col className="d-flex" md={2}>
                                <span className="mt-2 fw-bold">{item?.quarter?.name}</span>
                            </Col>
                            <Col md={13}>
                                <Form.Item name={`purpose-quarter-${index}`}>
                                    <TextArea
                                        rows={1}
                                        placeholder={`Nhập kết quả cần đạt ${item?.quarter?.name}`}
                                        size="large"
                                        disabled={isQuarterDisabled}
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={1} />
                            <Col md={3}>
                                <DatePickerCustomValidate
                                    form={form}
                                    index={index}
                                    item={item?.quarter}
                                    messageRequired={'Hãy chọn ngày bắt đầu'}
                                    name={`startDate-quarter-${index}`}
                                    placeholder="Chọn ngày bắt đầu"
                                    initialValue={dayjs(item?.quarter?.startDate)}
                                    disabled={isQuarterDisabled}
                                />
                            </Col>
                            <Col md={1} />
                            <Col md={4}>
                                <DatePickerCustomValidate
                                    form={form}
                                    index={index}
                                    item={item?.quarter}
                                    messageRequired={'Hãy chọn thời hạn hoàn thành'}
                                    name={`dueDate-quarter-${index}`}
                                    placeholder="Chọn thời hạn hoàn thành"
                                    initialValue={dayjs(item?.quarter?.endDate)}
                                    disabled={isQuarterDisabled}
                                />
                            </Col>
                        </Row>
                    );
                });
            }
            // When creating new, use data from lesserPlanPeriod
            else if (isNew) {
                return lesserPlanPeriod?.quarters?.map((item, index) => {
                    const isQuarterDisabled = isReadOnly || item?.quarter?.isEditAble === false;
                    return (
                        <Row key={item.quarter?.id || index}>
                            <Col className="d-flex" md={2}>
                                <span className="mt-2 fw-bold">{item?.quarter?.name}</span>
                            </Col>
                            <Col md={13}>
                                <Form.Item name={`purpose-quarter-${index}`}>
                                    <TextArea
                                        rows={1}
                                        placeholder={`Nhập kết quả cần đạt ${item?.quarter?.name}`}
                                        size="large"
                                        disabled={isQuarterDisabled}
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={1} />
                            <Col md={3}>
                                <DatePickerCustomValidate
                                    form={form}
                                    index={index}
                                    item={item?.quarter}
                                    messageRequired={'Hãy chọn ngày bắt đầu'}
                                    name={`startDate-quarter-${index}`}
                                    placeholder="Chọn ngày bắt đầu"
                                    initialValue={dayjs(item?.quarter?.startDate)}
                                    disabled={isQuarterDisabled}
                                />
                            </Col>
                            <Col md={1} />
                            <Col md={4}>
                                <DatePickerCustomValidate
                                    form={form}
                                    index={index}
                                    item={item?.quarter}
                                    messageRequired={'Hãy chọn thời hạn hoàn thành'}
                                    name={`dueDate-quarter-${index}`}
                                    placeholder="Chọn thời hạn hoàn thành"
                                    initialValue={dayjs(item?.quarter?.endDate)}
                                    disabled={isQuarterDisabled}
                                />
                            </Col>
                        </Row>
                    );
                });
            }
        }
        return null;
    };

    const handleMapperMonthByPlanPeriod = (indexQuarter: number) => {
        // When editing, use data from krQualitativeEntity
        if (!isNew && krQualitativeEntity && krQualitativeEntity?.quarters && krQualitativeEntity?.quarters[indexQuarter] && krQualitativeEntity?.quarters[indexQuarter]?.months.length > 0) {
            return krQualitativeEntity?.quarters[indexQuarter]?.months?.map((item, index) => {
                const isMonthDisabled = isReadOnly || item?.isEditAble === false;
                return (
                    <Row key={item.id}>
                        <Col className="d-flex" md={2}>
                            <span className="mt-2 fw-bold">{item?.name}</span>
                        </Col>
                        <Col md={13}>
                            <Form.Item name={`purpose-quarter-${indexQuarter}-month-${index}`} rules={[
                                {
                                    required:
                                        indexQuarter === 0 ?
                                            purposeValueQuarterFirstValues &&
                                            !purposeValueQuarterFirstMonthFirstValues &&
                                            !purposeValueQuarterFirstMonthSecondValues &&
                                            !purposeValueQuarterFirstMonthThirdValues
                                            : undefined,
                                    message: 'Vui lòng Nhập'
                                },
                            ]}>
                                <TextArea
                                    rows={1}
                                    placeholder={`Nhập kết quả cần đạt ${item?.name}`}
                                    size="large"
                                    disabled={isMonthDisabled}
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={3}>
                            <DatePickerCustomValidate
                                form={form}
                                index={index}
                                item={item}
                                messageRequired={'Hãy chọn ngày bắt đầu'}
                                name={`startDate-quarter-${indexQuarter}-month-${index}`}
                                placeholder="Chọn ngày bắt đầu"
                                initialValue={dayjs(item?.startDate)}
                                disabled={isMonthDisabled}
                            />
                        </Col>
                        <Col md={1} />
                        <Col md={4}>
                            <DatePickerCustomValidate
                                form={form}
                                index={index}
                                item={item}
                                messageRequired={'Hãy chọn thời hạn hoàn thành'}
                                name={`dueDate-quarter-${indexQuarter}-month-${index}`}
                                placeholder="Chọn thời hạn hoàn thành"
                                initialValue={dayjs(item?.endDate)}
                                disabled={isMonthDisabled}
                            />
                        </Col>
                    </Row>
                );
            });
        }
        // When creating new, use data from lesserPlanPeriodTypes
        else if (isNew && lesserPlanPeriodTypes && lesserPlanPeriodTypes?.quarters && lesserPlanPeriodTypes?.quarters[indexQuarter] && lesserPlanPeriodTypes?.quarters[indexQuarter]?.months && lesserPlanPeriodTypes?.quarters[indexQuarter]?.months.length > 0) {
            return lesserPlanPeriodTypes.quarters[indexQuarter].months.map((item, index) => {
                const isMonthDisabled = isReadOnly || item?.isEditAble === false;
                return (
                    <Row key={item.id}>
                        <Col className="d-flex" md={2}>
                            <span className="mt-2 fw-bold">{item?.name}</span>
                        </Col>
                        <Col md={13}>
                            <Form.Item name={`purpose-quarter-${indexQuarter}-month-${index}`} rules={[
                                {
                                    required:
                                        indexQuarter === 0 ?
                                            purposeValueQuarterFirstValues &&
                                            !purposeValueQuarterFirstMonthFirstValues &&
                                            !purposeValueQuarterFirstMonthSecondValues &&
                                            !purposeValueQuarterFirstMonthThirdValues
                                            : undefined,
                                    message: 'Vui lòng Nhập'
                                },
                            ]}>
                                <TextArea
                                    rows={1}
                                    placeholder={`Nhập kết quả cần đạt ${item?.name}`}
                                    size="large"
                                    disabled={isMonthDisabled}
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={3}>
                            <DatePickerCustomValidate
                                form={form}
                                index={index}
                                item={item}
                                messageRequired={'Hãy chọn ngày bắt đầu'}
                                name={`startDate-quarter-${indexQuarter}-month-${index}`}
                                placeholder="Chọn ngày bắt đầu"
                                initialValue={dayjs(item?.startDate)}
                                disabled={isMonthDisabled}
                            />
                        </Col>
                        <Col md={1} />
                        <Col md={4}>
                            <DatePickerCustomValidate
                                form={form}
                                index={index}
                                item={item}
                                messageRequired={'Hãy chọn thời hạn hoàn thành'}
                                name={`dueDate-quarter-${indexQuarter}-month-${index}`}
                                placeholder="Chọn thời hạn hoàn thành"
                                initialValue={dayjs(item?.endDate)}
                                disabled={isMonthDisabled}
                            />
                        </Col>
                    </Row>
                );
            });
        }
        return null;
    };

    const itemMonths: CollapseProps['items'] = [
        {
            key: '1',
            label: <span className='fw-bold'>Chi tiết quý 1 </span>,
            children: handleMapperMonthByPlanPeriod(0),
        },
        {
            key: '2',
            label: <span className='fw-bold'>Chi tiết quý 2 </span>,
            children: handleMapperMonthByPlanPeriod(1),
        },
        {
            key: '3',
            label: <span className='fw-bold'>Chi tiết quý 3 </span>,
            children: handleMapperMonthByPlanPeriod(2),
        },
        {
            key: '4',
            label: <span className='fw-bold'>Chi tiết quý 4 </span>,
            children: handleMapperMonthByPlanPeriod(3),
        },
    ];

    const handleEditObjective = () => {
        setIsOpenModalFormObjective(true);
    };

    const handleCloseModelObjective = (isReload = false) => {
        setIsOpenModalFormObjective(false);
    };

    const handleLesserPlanPeriod = async (planPeriodId: string) => {

        if (!selectedPeriod) {
            if (filters?.adjustPlanPeriod === 2) {
                await dispatch(getDivergenceNextPlanPeriodTest(planPeriodId));
                return
            }
            else if (filters?.adjustPlanPeriod === 1) {
                await dispatch(getDivergenceNextPlanPeriod(planPeriodId));
                return
            }
            return
        }

        if (selectedPeriod === 2) {
            await dispatch(getDivergenceNextPlanPeriod(planPeriodId));
            return
        } else {
            await dispatch(getDivergenceNextPlanPeriodTest(planPeriodId));
            return
        }


    };

    const handleNextKr = () => {
        form
            .validateFields()
            .then(values => {
                const {
                    tags,
                    informEmails,
                    consultantIds,
                    accountableId,
                    responsibleIds,
                    associateIds,
                    evaluationMethods,
                    krType,
                    planPeriodId,
                    frequencyId,
                    accessIds,
                    sendingNotification,
                    purpose,
                    startDate,
                    dueDate,
                    alignCode,
                    ...remainingValues
                } = values;
                let quarters = [];
                const months = [];
                // Khởi tạo mảng khóa
                const keys = Object.keys(remainingValues);
                // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
                const groupedKeys = _.chunk(keys, 3);

                // Separate arrays using lodash filter

                const monthArray = _.filter(groupedKeys, item => item && item[0] && item[0].includes('month'));
                const quarterArray = _.differenceWith(groupedKeys, monthArray, _.isEqual);
                // Tạo mảng mới từ các nhóm khóa
                quarters = _.map(quarterArray, group => {
                    const mapper = _.map(group, key => {
                        if (key.includes('startDate') || key.includes('dueDate')) {
                            return dayjs(remainingValues[key]).format(APP_LOCAL_DATE_FORMAT_PAYLOAD); // Định dạng ngày theo ý muốn
                        }
                        return remainingValues[key];
                    });
                    return _.zipObject(['purpose', 'startDate', 'dueDate'], mapper);
                });

                // Group data into the array by quarter and month
                _.forEach(remainingValues, (value, key) => {
                    const indices = extractQuarterAndMonth(key);
                    if (indices) {
                        const { quarter, month } = indices;
                        if (!months[quarter]) months[quarter] = [];
                        // Ensure the month is correctly filled within the quarter
                        if (!months[quarter][month]) {
                            months[quarter][month] = {};
                        }

                        // Add the value to the appropriate quarter and month
                        const type = key.split('-')[0]; // Extract 'dueDate', 'purpose', 'startDate'
                        months[quarter][month][type] = dayjs.isDayjs(value) ? dayjs(value).format(APP_LOCAL_DATE_FORMAT_PAYLOAD) : value;
                    }
                });

                quarters = quarters.map((item, index) => {
                    return {
                        quarter: {
                            ...item,
                            planPeriodId: lesserPlanPeriod?.quarters[index]?.quarter.id,
                            purpose: item.purpose !== undefined && item.purpose != null ? item.purpose : "",
                        },
                        months: months[index] ? months[index].map((itemMonth, indexMonth) => {
                            return {
                                ...itemMonth,
                                planPeriodId: lesserPlanPeriodTypes?.quarters && lesserPlanPeriodTypes?.quarters[index] ? lesserPlanPeriodTypes?.quarters[index].months[indexMonth].id : "",
                                startDate: lesserPlanPeriodTypes?.quarters && lesserPlanPeriodTypes?.quarters[index] ? lesserPlanPeriodTypes?.quarters[index]?.months[indexMonth].startDate : null,
                                dueDate: lesserPlanPeriodTypes?.quarters && lesserPlanPeriodTypes?.quarters[index] ? lesserPlanPeriodTypes?.quarters[index]?.months[indexMonth].endDate : null,
                                purpose: itemMonth.purpose !== undefined && itemMonth.purpose != null ? itemMonth.purpose : ""
                            };
                        }) : []
                    };
                });


                const detailEntity = !isNew ? krQualitativeEntity : undefined;
                const entity = {
                    ...detailEntity,
                    evaluationMethods,
                    krType,
                    accessIds,
                    planPeriodId,
                    frequencyId,
                    sendingNotification,
                    associateIds: associateIds ?? [],
                    tags: _.split(tags, ','),
                    objectiveId: id ?? idObjective,
                    raci: {
                        informEmails: _.split(informEmails, ','),
                        consultantIds,
                        accountableId,
                        responsibleIds,
                    },
                    quarters,
                    year: {
                        startDate: dayjs(startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                        dueDate: dayjs(dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                        purpose,
                        planPeriodId: lesserPlanPeriod?.year.id
                    },
                };
                dispatch(copyEntity(entity))
                    .then(res => {
                        if (res && res.payload) {
                            form.resetFields();
                            setSaveChange(true);
                        }
                    })
                    .catch(() => {
                        return;
                    });

            })
            .catch(() => {
                return;
            });
    };

    const handleShowMonth = (index: number) => {
        const months = [...showMonth]
        if (months.includes(index)) {
            const indexMonth = months.indexOf(index);
            months.splice(indexMonth, 1);
        }
        else {
            months.push(index);
        }
        setShowMonth(_.uniq(months));
    }

    const handleCloseModal = (isUpdateValue = true, itemSelected = []) => {
        if (isUpdateValue) {
            form.setFieldsValue(
                {
                    alignCode: itemSelected.length > 0 ? `${_.join(itemSelected.map(x => x.code), " ,")}` : null,
                    associateIds: itemSelected.map(x => x.id)
                }
            );
        }
        setOpenModal(false)
    }

    const handleOpenModalViewRowSelection = () => {
        setOpenModal(true)
    }

    return (
        <Spin delay={300} spinning={loadingQualitative}>
            <Container className="form">
                <Form
                    size="large"
                    form={form}
                    initialValues={{
                        sendingNotification: false,
                    }}
                    onFinish={handleSubmit}
                    layout="vertical"
                    disabled={isReadOnly}
                >
                    <Title level={3}>{isNew ? `Thêm mới` : `Cập nhật thông tin`} KR</Title>

                    <Form.Item>
                        <Collapse items={items} />
                    </Form.Item>
                    <Row>
                        <Col md={3}>
                            <Form.Item
                                label="Kỳ kế hoạch"
                                initialValue={planPeriodIdSelected}
                                rules={[{ required: true, message: 'Hãy chọn kỳ kế hoạch' }]}
                                name="planPeriodId"
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    size="large"
                                    disabled={!isNew || isReadOnly}
                                    filterOption={filterOption}
                                    options={planPeriodList.map(x => {
                                        return {
                                            label: x.name,
                                            value: x.id,
                                        };
                                    })}
                                    placeholder="Chọn kỳ kế hoạch"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={14}>
                            <Form.Item label="Mục tiêu, KR liên kết" name="associateIds">
                                <Row gutter={8} align="middle">
                                    <Col flex="auto">
                                        <Form.Item noStyle
                                            name={'alignCode'}>
                                            <Input
                                                readOnly
                                                size="large"
                                                placeholder="Chọn mục tiêu, KR liên kết"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Button
                                            className="primary"
                                            size="large"
                                            onClick={handleOpenModalViewRowSelection}
                                            icon={<PlusOutlined />}
                                        >
                                        </Button>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={5}>
                            <Form.Item
                                label="Loại KR"
                                rules={[{ required: true, message: 'Hãy chọn loại KR' }]}
                                name="krType"
                                initialValue={KrType}
                            >
                                <Select filterOption={filterOption} allowClear showSearch size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} onChange={handleChangeKRType} options={krTypes} placeholder="Chọn loại KR" />
                            </Form.Item>
                        </Col>
                    </Row>
                    {planPeriodSelected &&
                        <Row key={'purpose-year'}>
                            <Col className="d-flex align-items-center" md={2}>
                                <span className="mt-2 fw-bold">{`${lesserPlanPeriod ? lesserPlanPeriod?.year?.name : ''}`}</span>
                            </Col>
                            <Col md={13}>
                                <Form.Item
                                    label={`Kết quả cần đạt được`}
                                    rules={[{ required: true, message: 'Hãy nhập kết quả cần đạt được' }]}
                                    name={'purpose'}
                                >
                                    <TextArea rows={1} placeholder="Nhập kết quả cần đạt được" size="large"
                                        disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} />
                                </Form.Item>
                            </Col>
                            <Col md={1} />
                            <Col md={3}>
                                <Form.Item initialValue={dayjs().startOf('year')} rules={[{ required: true, message: 'Hãy chọn ngày bắt đầu' }]} label="Ngày bắt đầu" name={'startDate'}>
                                    <DatePicker
                                        minDate={dayjs(mintDate)}
                                        maxDate={dayjs(maxDate)}
                                        className="w-100"
                                        size="large"
                                        disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                        format={APP_LOCAL_DATE_FORMAT}
                                        placeholder="Chọn ngày bắt đầu"
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={1} />
                            <Col md={4}>
                                <Form.Item
                                    initialValue={dayjs().endOf('year')}
                                    rules={[{ required: true, message: 'Hãy chọn thời hạn hoàn thành' }]}
                                    label="Thời hạn hoàn thành"
                                    name={'dueDate'}
                                >
                                    <DatePicker
                                        minDate={dayjs(mintDate)}
                                        maxDate={dayjs(maxDate)}
                                        className="w-100"
                                        size="large"
                                        disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                        format={APP_LOCAL_DATE_FORMAT}
                                        placeholder="Chọn thời hạn hoàn thành"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>}

                    {planPeriodSelected && handleMapperResultByPlanPeriod()}
                    <Collapse items={itemMonths} defaultActiveKey={['1']} />

                    <Row>
                        <Col md={3}>
                            <Form.Item
                                label="Tần suất báo cáo"
                                rules={[{ required: true, message: 'Hãy chọn tần suất báo cáo' }]}
                                name="frequencyId"
                            >
                                <Select
                                    filterOption={filterOption}
                                    allowClear
                                    showSearch
                                    size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                    options={frequencies}
                                    placeholder="Chọn tần suất báo cáo"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={6}>
                            <Form.Item
                                label="Cách đánh giá tỷ lệ hoàn thành"
                                rules={[{ required: true, message: 'Hãy chọn cách đánh giá' }]}
                                name="evaluationMethods"
                            >
                                <Checkbox.Group
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} className="d-grid" options={qualityEvaluationTypes} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={7}>
                            <Form.Item
                                label="Người thực hiện chính (PIC)"
                                rules={[{ required: true, message: 'Hãy chọn người thực hiện chính' }]}
                                name="accountableId"
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    size="large"
                                    filterOption={filterOption}
                                    options={employeeList.map(x => {
                                        return {
                                            label: x.name,
                                            value: x.id,
                                        };
                                    })}
                                    placeholder="Chọn người thực hiện chính"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={7}>
                            <Form.Item label="Các bên tham gia thực hiện trực tiếp" name="responsibleIds">
                                <Select
                                    allowClear
                                    showSearch
                                    mode="multiple"
                                    size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                    filterOption={filterOption}
                                    options={employeeList.map(x => {
                                        return {
                                            label: x.name,
                                            value: x.id,
                                        };
                                    })}
                                    placeholder="Chọn các bên tham gia thực hiện trực tiếp"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={8}>
                            <Form.Item label="Các bên hỗ trợ" name="consultantIds">
                                <Select
                                    allowClear
                                    showSearch
                                    mode="multiple"
                                    size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                    filterOption={filterOption}
                                    options={employeeList.map(x => {
                                        return {
                                            label: x.name,
                                            value: x.id,
                                        };
                                    })}
                                    placeholder="Chọn các bên hỗ trợ"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={7}>
                            <Form.Item label="Người nhận thông báo (cách nhau dấu phẩy)" name={'informEmails'}>
                                <TextArea
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} rows={1} placeholder="Nhập người nhận thông báo" size="large" />
                            </Form.Item>
                            <Form.Item valuePropName="checked" name={'sendingNotification'}>
                                <Checkbox
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}>Gửi thông báo đến người nhận</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={7}>
                            <Form.Item label="Phân quyền truy cập" name={'accessIds'}>
                                <Select
                                    filterOption={filterOption}
                                    allowClear
                                    showSearch
                                    mode='multiple'
                                    size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                    options={employeeList.map(x => {
                                        return {
                                            label: x.name,
                                            value: x.id,
                                        };
                                    })}
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={8}>
                            <Form.Item label="Tag" name={'tags'}>
                                <TextArea
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} rows={1} placeholder="Nhập tag" size="large" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Row className="action mt-3" justify="end">
                            {isNew && (
                                <Col>
                                    <Button className="green" onClick={handleNextKr} disabled={updatingQualitative}>
                                        Lưu & Tạo KR khác
                                    </Button>
                                </Col>
                            )}
                            <Col>
                                <Button
                                    className="secondary"
                                    onClick={() => {
                                        handleClose();
                                    }}
                                    disabled={updatingQualitative}
                                >
                                    Hủy
                                </Button>
                            </Col>
                            <Col>
                                <Button className="primary" htmlType="submit" disabled={updatingQualitative || isReadOnly}>
                                    Lưu
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Container>
            {isOpenModalFormObjective && (
                <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={id ?? idObjective} onClose={handleCloseModelObjective} />
            )}
            {isOpenModal &&
                <ObjectiveKRRowSelection defaultSelected={[]} isOpen={isOpenModal} onClose={handleCloseModal} />
            }
        </Spin>
    );
};

export default CopyKRQualitative;
